// Base
import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import TileContent from "../Tile/TileContent";

const ProductBuyBoxContent = forwardRef((props, ref) => {
  const { children, ...restProps } = props;

  return (
    <TileContent ref={ref} {...restProps}>
      {children}
    </TileContent>
  );
});

ProductBuyBoxContent.displayName = "ProductBuyBox.Content";

ProductBuyBoxContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

ProductBuyBoxContent.defaultProps = {};

export default ProductBuyBoxContent;
